
export default {
    // @Business
    setNewCreatedBusiness(state, value){
        state.newCreatedBusiness = value
    },
}